import { DifficultyLevel } from '../interfaces/question.interface';
import { CubeFillRound } from '../interfaces/cube-fill.interface';

function randInt(lo: number, hi: number): number {
  return lo + Math.floor(Math.random() * (hi - lo + 1));
}

/** Dimension ranges per difficulty (kept modest so cubes stay countable and
 *  the gauge readable). */
function dimsFor(d: DifficultyLevel): { l: number; w: number; h: number } {
  if (d === DifficultyLevel.EASY) return { l: randInt(2, 4), w: randInt(2, 3), h: randInt(2, 3) };
  if (d === DifficultyLevel.MEDIUM) return { l: randInt(3, 5), w: randInt(2, 4), h: randInt(2, 4) };
  return { l: randInt(3, 5), w: randInt(3, 4), h: randInt(3, 5) }; // HARD
}

/** Gauge scale — generous headroom (≈20 above the volume, min 40) so a student
 *  can also pour an over-estimate and watch it overflow, and so the top of the
 *  scale never hints at the answer. */
function gaugeMaxFor(volume: number): number {
  return Math.max(40, Math.ceil(volume / 10) * 10 + 20);
}

function toRound(d: DifficultyLevel, idx: number): CubeFillRound {
  const { l, w, h } = dimsFor(d);
  const volume = l * w * h;
  return { id: `cube-${idx}-${l}x${w}x${h}`, l, w, h, volume, gaugeMax: gaugeMaxFor(volume), difficulty: d };
}

/** Build a session's rounds on a gentle easy→hard ramp. */
export function buildCubeFillRounds(count: number): CubeFillRound[] {
  const n = Math.max(1, count);
  const out: CubeFillRound[] = [];
  for (let i = 0; i < n; i++) {
    const t = n === 1 ? 0 : i / (n - 1);
    let d: DifficultyLevel;
    if (t < 0.34) d = DifficultyLevel.EASY;
    else if (t < 0.7) d = DifficultyLevel.MEDIUM;
    else d = DifficultyLevel.HARD;
    out.push(toRound(d, i));
  }
  return out;
}
